import useGameReviewBase from './useGameReviewBase';

/**
 * Custom hook for FreeKickGameReview component
 * Manages state and business logic for the Free Kick game review page
 */
const useFreeKickGameReview = (activityFormData) => {
  return useGameReviewBase(activityFormData);
};

export default useFreeKickGameReview;
